import type { ReadyEvent } from "./protocol.ts";

/**
 * The language to follow by default: one this session translates into.
 * The device or remembered language wins only if it is one of those; the
 * original (untranslated) language is never picked automatically, because it
 * has no translation to speak (a French phone at a French sermon heard nothing).
 */
export function defaultLanguage(ready: ReadyEvent, wanted: (string | null)[]): string | null {
  const translated = ready.attendeeLanguages?.length
    ? ready.attendeeLanguages
    : (ready.listenerLanguages ?? []).filter((l) => l !== ready.plan.source || ready.plan.direction === "two-way");
  return wanted.find((l): l is string => !!l && translated.includes(l)) ?? translated[0] ?? ready.plan.target ?? null;
}
